module.exports = __webpack_public_path__ + "static/media/6process-working.c5224518.png";